if (!customElements.get("header-nav")) {
  class HeaderNav extends HTMLElement {
    constructor() {
      super();

      this.CSSRoot = document.querySelector(":root");
    }

    get height() {
      return parseInt(this.offsetHeight);
    }

    set CSSRootHeight(height) {
      this.CSSRoot.style.setProperty("--nav-height", height + "px");
    }

    connectedCallback() {
      this.CSSRootHeight = this.height;

      window.addEventListener(
        "resize",
        () => (this.CSSRootHeight = this.height)
      );

      this.addEventListener(
        "nav-height-change",
        () => (this.CSSRootHeight = this.height)
      );
    }
  }
  customElements.define("header-nav", HeaderNav);
}

(function () {
  let prevTopDistance = window.scrollY;
  let prevDir = "";
  var headerNav = document.querySelector("header-nav");

  function dispatchNavChange() {
    headerNav.dispatchEvent(new CustomEvent("nav-height-change"));
  }

  if (window.innerWidth < 980) {
    window.addEventListener(
      "scroll",
      function () {
        if (window.scrollY > prevTopDistance && prevDir !== "down" && window.scrollY > 200) {
          prevDir = "down";
          headerNav.classList.add("hide--searchbar");
          document.body.classList.add("hide--searchbar");
        } else if (window.scrollY < prevTopDistance && prevDir !== "up") {
          prevDir = "up";
          document.body.classList.remove("hide--searchbar");
          headerNav.classList.remove("hide--searchbar");
        }

        if (window.scrollY > 200) {
            headerNav.classList.add('sticked-nav');
        } else {
            headerNav.classList.remove('sticked-nav');
        }

       // dispatchNavChange();

        prevTopDistance = window.scrollY <= 0 ? 0 : window.scrollY;
      },
      false
    );
  }
})();
